import { Injectable } from "@angular/core";
import { GlobalSearchRepository } from "../../../domain/repositories/global-search.repositories";

@Injectable({
  providedIn: "root",
})
export class GlobalSearchService {
  constructor(private globalSearchRepo: GlobalSearchRepository) {}

  retrieveGlobalData(query: string) {
    return this.globalSearchRepo.search(query);
  }

  retrieveAllDocumentsOfType(type: string, query: string) {
    return this.globalSearchRepo.searchByType(type.toLowerCase(), query);
  }
}
